import React, { useState } from "react";
import { Card, CardBody, CardHeader, CardTitle, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from "classnames";

import TinyCustomSettlements from "./TinyCustomSettlements";
import TinySettlementImportTab from "./TinySettlementImportTab";
import TinySpecialRules from "./TinySpecialRules";
import TinySettlementReviewTab from "./TinySettlementReviewTab";

import TinyPageHeader from "components/tiny/TinyPageHeader";
function TinySettlementCenter() {
  const [activeTab, setActiveTab] = useState("manual");

  return (
    <div className="content">
      {/* 這頁原本是 Card > CardHeader(標題) + CardBody(tabs + 內容) 的包法，
          tab 的 active 還自己寫了一份紫色漸層。改成公版。 */}
      <TinyPageHeader
        title="額外交收中心"
        description="常態分潤之外的交收：手動登記、活動獎勵匯入與審核，以及特殊規則。"
        tabs={{
          items: [
            { key: "manual", label: "手動登記", icon: "fa fa-pen-to-square" },
            { key: "import", label: "活動匯入", icon: "fa fa-upload" },
            { key: "review", label: "審核", icon: "fa fa-square-check" },
            { key: "rules", label: "特殊規則", icon: "fa fa-gavel" },
          ],
          active: activeTab,
          onChange: setActiveTab,
        }}
      />

      <TabContent activeTab={activeTab}>
        <TabPane tabId="manual">
          <TinyCustomSettlements />
        </TabPane>
        <TabPane tabId="import">
          <TinySettlementImportTab />
        </TabPane>
        <TabPane tabId="review">
          <TinySettlementReviewTab />
        </TabPane>
        <TabPane tabId="rules">
          <TinySpecialRules embedded />
        </TabPane>
      </TabContent>
    </div>
  );
}

export default TinySettlementCenter;

